import { Button } from "./Button";
import { Primary } from "../../Flavor";
import logo from "../../assets/logo.png";

interface RulesModalProps {
  onClose: () => void;
  visible: boolean;
}

export const RulesModal = (props: RulesModalProps) => {
  if (!props.visible) return <></>;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-10">
      <div className="absolute w-screen h-screen bg-gray-500 opacity-50 z-10"></div>
      <div className="relative w-[70vw] h-[70vh] shadow rounded-lg bg-white z-20 p-10 flex flex-col justify-between">
        <div>
          <h2 className="text-2xl border-b p-2">My Little Planet</h2>
          <div className="flex items-center gap-2">
            <div className="mt-5 p-2">
              <h2 className="text-xl">Règles du jeu</h2>

              <p className="mt-2">
                My Little Planet est un jeu de gestion qui a pour but de
                sensibiliser aux problèmes climatiques.
              </p>
              <p className="mt-2">
                Vous devez gérer votre planète en faisant les bons choix selon
                les cartes qui vous sont proposées.
              </p>
              <br />

              <div className="mt-2">
                Vous aurez 2 choix :
                <ul className="list-disc">
                  <li className="ml-4">Prendre une carte et l'appliquer</li>
                  <li className="ml-4">Ne pas prendre de carte</li>
                </ul>
              </div>

              <div className="mt-2">
                Une jauge de climat est présente en haut à gauche de l'écran.
                Elle représente l'état de votre planète.
              </div>
            </div>

            <div className="w-1/3 h-1/3 flex items-center justify-center">
              <img src={logo} alt="logo" className="w-36 h-36" />
            </div>
          </div>
        </div>
        <Button
          label="C'est parti !"
          onClick={props.onClose}
          className="mt-5 justify-end"
          flavor={Primary}
        />
      </div>
    </div>
  );
};
